import React from 'react'
import Box from '@mui/joy/Box'
import Checkbox from '@mui/joy/Checkbox'
import { useTranslation } from 'react-i18next'

import { FiltersType } from '../types'

export default function FullGarageToggleIsolated({
    currentFilters,
    setCurrentFilters,
}:{
    currentFilters: FiltersType,
    setCurrentFilters: Function,
}) {

    const { t } = useTranslation()

    /**
     * Saves checked status into the state fields object
     * @param {*} event 
     */
    const handleChecked = ({
        target: {
            name,
            checked,
        },
    }) => {
        setCurrentFilters(prevState => (
            {
                ...prevState,
                [name]: checked,
            }
        ))
    }

  return (
    <Box>
        <Checkbox
            label={t('filters.showAvailable')}
            variant="outlined"
            sx={{
            marginTop: 1,
            fontSize: '0.9rem',
            paddingRight: '0.625rem',
            }}
            checked={currentFilters.showAvailable}
            name="showAvailable"
            onChange={handleChecked}
        />
    </Box>
  )
}